'use strict';

export function inviewFade(){

    $(function(){

        // inview で classの付与
        $('.js-light-target__target').on('inview',function(event,isInView){
            
            const windowWidth = window.innerWidth;

            if(windowWidth <= 767){

                if (isInView) {

                    $(this).addClass('is-show');

                } else {
                    $(this).removeClass('is-show');
                }

            }


        });


        $('.js-fade-target').on('inview',function(event,isInView){
            
            if (isInView) {

                $(this).addClass('is-show');

            } 

        });

    })
}